export default "__VITE_ASSET__61ba1fa0__"